<template>
  <div class="col-12 col-lg-6 c g">
    <div class="card card-body">
        <template v-if="!hudury.enabled || hudury.status != 1">
            <div class="alert alert-danger text-center g">
                <h3>
                    قم بتفعيل الربط مع حضوري أولاً.
                </h3>
            </div>
        </template>
        <template v-if="hudury.enabled && hudury.status == 1">
            <div class="form-group">
              <h5 for="">الفترة من</h5>
              <input type="date"
                class="form-control" v-model="from">
            </div>
            <div class="form-group">
              <h5 for="">الفترة الى</h5>
              <input type="date"
                class="form-control" v-model="to">
            </div>
            <div class="col-12 text-center g">
                <button class="btn btn-primary" @click="gett()">
                    استيراد التقارير الآن
                </button>
            </div>
        </template>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            user: JSON.parse(localStorage.getItem('user')),
            hudury: {
                enabled: false,
                status: 0,
                users: [],
                last_active: "--"
            },
            from: new Date().toISOString().split("T")[0],
            to: new Date().toISOString().split("T")[0],
        }
    },
    created(){
        var g = this;
        $.post(api + '/user/teachers/hudury/settings', {
            jwt: g.user.jwt
        }).then(function(r){
            g.hudury = r.response
        })
    },
    methods: {
        gett(){
            var g = this;
            $.post(api + '/user/teachers/hudury/import', {
                jwt: g.user.jwt,
                from: g.from,
                to: g.to
            }).then(function(r){
                if(r.status == 100){
                    alert("تم ارسال الطلب بنجاح، قد تستغرق العملية بضع دقائق حتى تظهر في الموقع.", 100)
                }else{
                    alert(r.response, 200)
                }
            })
        }
        
    }
}
</script>

<style>

</style>